import { PostGrid } from "../components/PostGrid";

function Insights() {
  return (
    <PostGrid 
      section="insights" 
      title="Market Insights" 
      description="Structured financial research and market analysis modules." 
    />
  );
}

export default Insights;
